import React from "react";
import { Button, ColorPicker, Input, InputNumber, Space, Tooltip } from "antd";
import { Content } from "antd/es/layout/layout";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { PALETA_TEXTO } from "./tema";

const PRESETS = [
  { label: "Cores da casa", colors: PALETA_TEXTO.map((c) => c.cor) },
];

/**
 * Editor de uma linha de texto colorido (título ou subtítulo).
 *
 * O título das referências mistura cores numa linha só ("Soja" em amarelo,
 * o resto em branco, a unidade menor). Guardar isso como uma lista de
 * segmentos — em vez de HTML solto — é o que permite ao usuário pintar
 * palavra por palavra sem digitar marcação, e o que garante que só saia
 * markup que o Highcharts converte em <tspan> (o único que sobrevive à
 * exportação da imagem).
 */
export default function EditorSegmentos({ valor = [], onChange, rotulo }) {
  const segmentos = Array.isArray(valor) ? valor : [];

  const alterar = (indice, campo, novo) => {
    const copia = segmentos.map((s, i) => (i === indice ? { ...s, [campo]: novo } : s));
    onChange(copia);
  };

  const adicionar = () =>
    onChange([...segmentos, { texto: "", cor: "#FFFFFF" }]);

  const remover = (indice) =>
    onChange(segmentos.filter((_, i) => i !== indice));

  return (
    <Content style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {segmentos.map((segmento, i) => (
        <Space.Compact key={i} style={{ width: "100%" }}>
          <Input
            value={segmento.texto}
            placeholder={i === 0 ? rotulo : "trecho"}
            onChange={(e) => alterar(i, "texto", e.target.value)}
          />
          <Tooltip title="Cor deste trecho">
            <ColorPicker
              value={segmento.cor || "#FFFFFF"}
              presets={PRESETS}
              disabledAlpha
              onChange={(cor) => alterar(i, "cor", cor.toHexString())}
            />
          </Tooltip>
          <Tooltip title="Tamanho da fonte deste trecho (vazio = padrão)">
            <InputNumber
              style={{ width: 62 }}
              min={5}
              max={20}
              placeholder="tam"
              value={segmento.tamanho}
              onChange={(v) => alterar(i, "tamanho", v ?? undefined)}
            />
          </Tooltip>
          <Button
            icon={<DeleteOutlined />}
            danger
            onClick={() => remover(i)}
            disabled={segmentos.length === 1}
          />
        </Space.Compact>
      ))}
      <Button size="small" icon={<PlusOutlined />} onClick={adicionar} style={{ alignSelf: "start" }}>
        Trecho
      </Button>
    </Content>
  );
}
